
<div class="row m-0">
  <div class="col-4">

    @if (dados!=null) {
      <table class="table table-bordered">
        <tbody>
          <tr>
            <th>Nome:</th>
            <td>{{dados.NOME_ASSOCIADO}}</td>
          </tr>
          <tr>
            <th>CPF:</th>
            <td>{{dados.DCR_CPF_ASSOCIADO}}</td>
          </tr>
          <tr>
            <th>Parentesco:</th>
            <td>{{dados.DCR_PARENTESCO_EXT}}</td>
          </tr>
        </tbody>
      </table>
    }
  </div>
</div>